import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Chain: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg
            style={{ display: 'inline-flex' }}
            className={clss}
            width={width ?? 20}
            height={height ?? 20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#chain-clip)">
                <path
                    d="M8.33333 10.8333C8.69121 11.3118 9.1478 11.7077 9.67212 11.9941C10.1965 12.2806 10.7763 12.4509 11.3722 12.4936C11.9682 12.5363 12.5663 12.4503 13.1261 12.2415C13.6859 12.0327 14.1943 11.7059 14.6167 11.2833L17.1167 8.78335C17.8757 7.9975 18.2956 6.94499 18.2861 5.85251C18.2766 4.76002 17.8384 3.71497 17.0659 2.94243C16.2934 2.1699 15.2483 1.7317 14.1558 1.7222C13.0633 1.71271 12.0108 2.13269 11.225 2.89168L9.79166 4.31668M11.6667 9.16668C11.3088 8.68824 10.8522 8.29236 10.3279 8.0059C9.80355 7.71943 9.22374 7.54908 8.62779 7.5064C8.03184 7.46372 7.43368 7.54971 6.87388 7.75853C6.31408 7.96735 5.80574 8.29412 5.38333 8.71668L2.88333 11.2167C2.12434 12.0025 1.70436 13.055 1.71386 14.1475C1.72335 15.24 2.16155 16.2851 2.93409 17.0576C3.70662 17.8301 4.75167 18.2683 5.84416 18.2778C6.93665 18.2873 7.98916 17.8673 8.775 17.1083L10.2 15.6833"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="chain-clip">
                    <rect width="20" height="20" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Chain;
